import React from "react";
import { useTranslation } from "react-i18next";
import MainDescription from "./MainDescription";
import { QuickRegisterWrapper } from "../styledComponents/StyledSlider";
import { StyledLink } from "../styledComponents/CommonStyledComponents";

const QuickRegister = ({
  skin,
  player,
  setEmail,
  setName,
  setLastName,
  handleQuickRegister,
  currentLanguage,
  banner,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {!player && (
        <QuickRegisterWrapper
          onSubmit={(e) => {
            e.preventDefault();
            handleQuickRegister();
          }}
        >
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("label_email_address")}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"
          />
          <input
            type="text"
            onChange={(e) => setName(e.target.value)}
            placeholder={t("label_name")}
          />
          <input
            type="text"
            onChange={(e) => setLastName(e.target.value)}
            placeholder={t("label_last_name")}
          />
          <StyledLink
            btn="true"
            as="button"
            slidcontroll="true"
            to={"/" + currentLanguage + banner.url}
          >
            {t("label_sign_up_now", "Register")}
          </StyledLink>
        </QuickRegisterWrapper>
      )}
      <MainDescription skin={skin} qbcIndex={true} />
    </>
  );
};

export default QuickRegister;
